import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { getEventCategoryChoices } from "@/lib/categories";

export function useEventCategories(currentValue = "") {
  const { data } = useQuery({
    queryKey: ["corporate-event-categories-enabled"],
    queryFn: async () => {
      // Missing RPC, permissions or network failure: preserve the existing form.
      try {
        const { data, error } = await supabase.rpc("corporate_event_categories_enabled");
        return !error && data === true;
      } catch {
        return false;
      }
    },
    staleTime: 60_000,
    retry: false,
  });
  const corporateEnabled = data === true;
  return { corporateEnabled, categories: getEventCategoryChoices(corporateEnabled, currentValue) };
}
